export const errorKeyMessages: Record<string, string> = {
  'Auth.PasswordResetRequired': 'You must reset your password before logging in.',
  INVALID_CREDENTIALS: 'Invalid email or phone number, or incorrect password.',
  ACCOUNT_LOCKED: 'Your account is locked. Please contact support.',
  USER_NOT_FOUND: 'No user found with the provided credentials.',
};
